import { render, staticRenderFns } from "./CardSpecimen.vue?vue&type=template&id=de8a183e&scoped=true"
import script from "./CardSpecimen.vue?vue&type=script&lang=js"
export * from "./CardSpecimen.vue?vue&type=script&lang=js"
import style0 from "./CardSpecimen.vue?vue&type=style&index=0&id=de8a183e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a183e",
  null
  
)

export default component.exports